import React from 'react'

const Processing = (props) => (
    <div className="container mt-4 mb-4" style={{ maxWidth: '400px' }}>
        <p className="text-center">Please wait...</p>
        <div className="progress progress-striped active">
            <div className="progress-bar bg-secondary progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{ width: '100%' }}>
                <span className="sr-only">100%</span>
            </div>
        </div>
    </div>
)

export default Processing